import React from 'react'
import BlogDetails from '../components/BlogPost/blogDetail';
import LoadingSpinner from '../components/Loader/LoadingSpinner';
import { useGetPostQuery } from '../reactWrapper/Redux/apiSlice';


export const SingleBlog =({ match })=>{
    const { postId } = match.params

    const { data: post, isFetching, isSuccess } = useGetPostQuery(postId)

        if (isFetching) {
            return(
                <LoadingSpinner />
            )

        } else if (isSuccess) {
            return(
                <div className='mx-auto max-w-7xl space-y-6'>
                    <BlogDetails post={post} />
                </div>
            )
        }

}
